import { plataformaElectron } from './electron';
import { plataformaWeb } from './web';
import type { PlataformaApp } from './tipos';

export type * from './tipos';

/**
 * Alvo escolhido em build time. `VITE_PLATAFORMA` é substituída como
 * constante pelo Vite, então o bundle de cada alvo descarta o ramo do
 * outro na minificação — o build web não carrega nada de Electron.
 */
const ALVO = import.meta.env.VITE_PLATAFORMA ?? 'electron';

export const plataforma: PlataformaApp =
  ALVO === 'web' ? plataformaWeb : plataformaElectron;

/** Atalho de leitura: `capacidades.autoUpdate`, `capacidades.alvo`, … */
export const capacidades = plataforma.capacidades;

/** `true` quando rodando no navegador. Use para ajustes pontuais de layout. */
export const ehWeb = capacidades.alvo === 'web';
